import { observer } from 'mobx-react-lite';
import { getSnapshot } from 'mobx-state-tree';
import * as React from 'react';
import { Cell, Grid } from 'styled-css-grid';

import { Button } from '../../ButtonV2/ButtonV2';
import { useFilterMobileStore, useFilterStore } from '../useStore';

interface FooterProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Footer = observer((props: FooterProps) => {
  const mobileStore = useFilterMobileStore();
  const filterStore = useFilterStore();

  return (
    <Grid>
      <Cell width={6} middle>
        <Button fullWidth type="secondary" variant="outline" onClick={() => mobileStore.setClose()}>
          Đóng
        </Button>
      </Cell>

      <Cell width={6} middle>
        <Button
          style={{ height: 40 }}
          fullWidth
          type="primary"
          variant="dark"
          onClick={() => {
            mobileStore.update({ page: 1 });
            filterStore.sync(getSnapshot(mobileStore));
            mobileStore.setClose();
          }}
        >
          Apply
        </Button>
      </Cell>
    </Grid>
  );
});
